import { z } from "zod"

export const TABS = [
  "overview",
  "tasks",
  "squawks",
  "customers",
  "asset",
  "parts",
  "dates",
  "activity",
] as const

export const tabSchema = z.enum(TABS)

export type Tab = z.infer<typeof tabSchema>

export function tabLabel(tab: Tab): string {
  switch (tab) {
    case "overview":
      return "Overview"
    case "tasks":
      return "Tasks"
    case "squawks":
      return "Squawks"
    case "customers":
      return "Customers"
    case "asset":
      return "Asset"
    case "parts":
      return "Parts"
    case "dates":
      return "Dates"
    case "activity":
      return "Activity"
  }
}

export const TASK_TABS = [
  "resolution",
  "steps",
  "labour",
  "parts",
  "tooling",
  "services",
  "notes",
  "sign-offs",
] as const

export const taskTabSchema = z.enum(TASK_TABS)

export type TaskTab = z.infer<typeof taskTabSchema>

export function taskTabLabel(tab: TaskTab): string {
  switch (tab) {
    case "resolution":
      return "Resolution"
    case "steps":
      return "Steps"
    case "labour":
      return "Labor"
    case "parts":
      return "Parts"
    case "tooling":
      return "Tooling"
    case "services":
      return "Services"
    case "notes":
      return "Notes"
    case "sign-offs":
      return "Sign-offs"
  }
}
